"use client";

import { useState } from "react";

const CONTACT_EMAIL = "contact@morgane.rabiet.fr.eu.org";

const serviceOptions = [
  "Avis confraternel écrit",
  "Télé-consultation",
  "Revue de dossier approfondie",
  "Enseignement / formation",
  "Autre demande",
];

const inputClasses =
  "w-full rounded-lg border border-brand-900/15 bg-white px-4 py-2.5 text-sm text-brand-950 placeholder:text-brand-900/40 focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20";

export function ContactForm() {
  const [clinic, setClinic] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [service, setService] = useState(serviceOptions[0]);
  const [message, setMessage] = useState("");

  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    const subject = `[${service}] Demande de ${clinic || name}`;
    const body = [
      `Structure : ${clinic}`,
      `Vétérinaire : ${name}`,
      `E-mail : ${email}`,
      phone ? `Téléphone : ${phone}` : null,
      `Service souhaité : ${service}`,
      "",
      message,
    ]
      .filter((line): line is string => line !== null)
      .join("\n");

    window.location.href = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid gap-4 sm:grid-cols-2">
        <div>
          <label
            htmlFor="clinic"
            className="mb-1.5 block text-sm font-medium text-brand-900"
          >
            Clinique / structure
          </label>
          <input
            id="clinic"
            type="text"
            required
            value={clinic}
            onChange={(e) => setClinic(e.target.value)}
            placeholder="Clinique vétérinaire des Lilas"
            className={inputClasses}
          />
        </div>
        <div>
          <label
            htmlFor="name"
            className="mb-1.5 block text-sm font-medium text-brand-900"
          >
            Vétérinaire référent
          </label>
          <input
            id="name"
            type="text"
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Dr Prénom Nom"
            className={inputClasses}
          />
        </div>
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        <div>
          <label
            htmlFor="email"
            className="mb-1.5 block text-sm font-medium text-brand-900"
          >
            E-mail professionnel
          </label>
          <input
            id="email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="vous@clinique.fr"
            className={inputClasses}
          />
        </div>
        <div>
          <label
            htmlFor="phone"
            className="mb-1.5 block text-sm font-medium text-brand-900"
          >
            Téléphone <span className="text-brand-900/50">(optionnel)</span>
          </label>
          <input
            id="phone"
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="06 00 00 00 00"
            className={inputClasses}
          />
        </div>
      </div>

      <div>
        <label
          htmlFor="service"
          className="mb-1.5 block text-sm font-medium text-brand-900"
        >
          Service souhaité
        </label>
        <select
          id="service"
          value={service}
          onChange={(e) => setService(e.target.value)}
          className={inputClasses}
        >
          {serviceOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label
          htmlFor="message"
          className="mb-1.5 block text-sm font-medium text-brand-900"
        >
          Votre demande
        </label>
        <textarea
          id="message"
          required
          rows={6}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Décrivez brièvement le cas ou votre besoin (espèce, âge, motif, examens déjà réalisés…). Les documents pourront être joints à l'e-mail."
          className={inputClasses}
        />
      </div>

      <button
        type="submit"
        className="w-full rounded-full bg-brand-700 px-6 py-3 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-brand-800 sm:w-auto"
      >
        Préparer l&apos;e-mail
      </button>
      <p className="text-xs leading-relaxed text-brand-900/60">
        Ce formulaire ouvre votre messagerie avec un e-mail pré-rempli — aucune
        donnée n&apos;est transmise ni conservée par ce site. Vous pourrez y
        joindre comptes rendus, analyses et imagerie avant l&apos;envoi.
      </p>
    </form>
  );
}
